import {useState} from 'react';

export type StaffMenuLocation={code:string;name:string};
export function StaffLocationMenu({
  locations,selectedLocation,onSelect,onCalendar,onShifts,onCashbox,onMerge,onPublic,onReservationsReport,onReport,onOpen,canManageLocationSettings=false,
}:{
  locations:StaffMenuLocation[];selectedLocation:string|null;
  onSelect:(code:string)=>void;onCalendar:()=>void;onShifts:()=>void;
  onCashbox:()=>void;onMerge:()=>void;onPublic:()=>void;
  onReservationsReport:()=>void;
  onReport:(kind:'Customers'|'Memberships'|'Service Credits'|'Gift Cards'|'Reservations')=>void;
  onOpen?:(page:'products'|'services'|'packages'|'memberships'|'gift-card-setup'|'discount-codes'|'waivers'|'shop-settings'|'auto-emails'|'referral-programs')=>void;
  canManageLocationSettings?:boolean;
}){
  const [locationsOpen,setLocationsOpen]=useState(false);
  const [setupOpen,setSetupOpen]=useState(false);
  const [reportsOpen,setReportsOpen]=useState(false);
  const setup=[
    'Products','Services','Packages','Memberships','Gift Cards',
    'Waivers','Discount Codes','Referral Programs','Employees',
    'Auto Emails','Task Generators','Payment Types','Location Settings',
    'Account Settings','Webhooks',
  ] as const;
  const reports=[
    'Overview','Customers','Employees','Memberships','Service Credits',
    'Credits','Gift Cards','Reservations','Payments','Payment Processing','Cashbox History',
  ] as const;
  return <div className="ecfs-location-menu" role="menu"
    aria-label="East Coast Float Spa locations and Team Member tools">
    <button type="button" className="ecfs-menu-location-toggle"
      aria-expanded={locationsOpen} aria-controls="ecfs-menu-location-options"
      onClick={()=>setLocationsOpen(open=>!open)}>
      East Coast Float Spa {locations.find(item=>item.code===selectedLocation)?.name??''}
      <span aria-hidden="true">{locationsOpen?'▴':'▾'}</span>
    </button>
    {locationsOpen&&<div id="ecfs-menu-location-options"
      className="ecfs-menu-locations" aria-label="Locations">
      {locations.map(item=><button type="button" role="menuitemradio"
        aria-checked={selectedLocation===item.code} key={item.code}
        onClick={()=>{onSelect(item.code);setLocationsOpen(false);}}>
        {item.name}{selectedLocation===item.code?' ✓':''}
      </button>)}
    </div>}
    <div className="ecfs-menu-items">
      <button type="button" role="menuitem" onClick={onCalendar}>Calendar</button>
      <button type="button" role="menuitem" onClick={onShifts}>Shift Schedule</button>
      <button type="button" disabled>Employee Timesheets</button>
      <button type="button" role="menuitem" onClick={onMerge}>Customer Merge Tool</button>
      <button type="button" disabled>Order Tracking</button>
      <button type="button" disabled>Inventory</button>
      <button type="button" role="menuitem" onClick={onCashbox}>Cashbox</button>
    </div>
    <div className="ecfs-menu-accordion">
      <button type="button" aria-expanded={setupOpen}
        aria-controls="ecfs-setup-submenu"
        onClick={()=>setSetupOpen(open=>!open)}>
        Setup <span aria-hidden="true">{setupOpen?'▴':'▾'}</span>
      </button>
      {setupOpen&&<div id="ecfs-setup-submenu" className="ecfs-menu-subitems">
        {setup.filter(item=>item!=='Location Settings'||canManageLocationSettings).map(item=>{
          const destination=item==='Products'?'products':
            item==='Services'?'services':
            item==='Packages'?'packages':
            item==='Memberships'?'memberships':
            item==='Gift Cards'?'gift-card-setup':
            item==='Discount Codes'?'discount-codes':
            item==='Waivers'?'waivers':
            item==='Referral Programs'?'referral-programs':
            item==='Location Settings'?'shop-settings':
              item==='Auto Emails'?'auto-emails':null;
          return <button key={item} type="button" role="menuitem"
            disabled={!destination||!onOpen}
            title={!destination?'This setup area needs its operational backend.':undefined}
            onClick={()=>{if(destination)onOpen?.(destination);}}>{item}</button>;
        })}
      </div>}
      <button type="button" aria-expanded={reportsOpen}
        aria-controls="ecfs-reports-submenu"
        onClick={()=>setReportsOpen(open=>!open)}>
        Reports <span aria-hidden="true">{reportsOpen?'▴':'▾'}</span>
      </button>
      {reportsOpen&&<div id="ecfs-reports-submenu" className="ecfs-menu-subitems">
        {reports.map(item=>{
          const supported=['Customers','Memberships','Service Credits',
            'Gift Cards','Reservations'].includes(item);
          return <button type="button" role="menuitem" key={item}
            disabled={!supported}
            title={supported?undefined:'Report data has not yet been imported.'}
            onClick={()=>{if(item==='Reservations')onReservationsReport();
              else if(supported)onReport(item as
                'Customers'|'Memberships'|'Service Credits'|'Gift Cards');}}>
              {item}</button>;
        })}
      </div>}
    </div>
    <div className="ecfs-shift-menu-section">
      <strong>Clocked In Now</strong>
      <p>Live clock-in information is not yet connected.</p>
    </div>
    <div className="ecfs-shift-menu-section">
      <strong>Coming Soon</strong>
      <p>Upcoming Team Member shifts are not yet connected.</p>
    </div>
    <button type="button" role="menuitem" className="ecfs-switch-surface"
      onClick={onPublic}>Public booking</button>
  </div>;
}
